"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _web = _interopRequireDefault(require("web3"));

var _protocols = _interopRequireDefault(require("./protocols"));

class LaminarContract {
  constructor({
    provider,
    protocolType = 'kovan'
  }) {
    this.getNetworkType = async () => this.web3.eth.net.getNetworkType();

    this.protocol = _protocols.default[protocolType];
    this.provider = provider;
    this.web3 = new _web.default(this.provider);
    const abis = this.protocol.abis;
    const addresses = this.protocol.addresses;
    this.baseContracts = {
      marginFlowProtocol: this.createContract(abis.MarginFlowProtocol, addresses.marginProtocol),
      marginFlowProtocolConfig: this.createContract(abis.MarginFlowProtocolConfig, addresses.marginProtocolConfig),
      marginFlowProtocolSafety: this.createContract(abis.MarginFlowProtocolSafety, addresses.marginProtocolSafety),
      marginLiquidityPoolRegistry: this.createContract(abis.MarginLiquidityPoolRegistry, addresses.marginPoolRegistry),
      syntheticFlowProtocol: this.createContract(abis.SyntheticFlowProtocol, addresses.syntheticProtocol),
      priceOracleInterface: this.createContract(abis.PriceOracleInterface, addresses.oracle),
      moneyMarket: this.createContract(abis.MoneyMarket, addresses.moneyMarket)
    };
    this.tokenIds = {
      DAI: addresses.baseToken,
      IUSD: addresses.iToken,
      FEUR: addresses.fEUR,
      FJPY: addresses.fJPY,
      FCAD: addresses.fCAD,
      FCHF: addresses.fCHF,
      FGBP: addresses.fGBP,
      FAUD: addresses.fAUD,
      FOIL: addresses.fUSOIL,
      FXAU: addresses.fXAU,
      FBTC: addresses.fBTC,
      FETH: addresses.fETH
    };
    this.tokenContracts = {
      DAI: this.createContract(abis.ERC20, this.tokenIds.DAI),
      IUSD: this.createContract(abis.ERC20, this.tokenIds.IUSD),
      FEUR: this.createContract(abis.ERC20, this.tokenIds.FEUR),
      FJPY: this.createContract(abis.ERC20, this.tokenIds.FJPY),
      FCAD: this.createContract(abis.ERC20, this.tokenIds.FCAD),
      FCHF: this.createContract(abis.ERC20, this.tokenIds.FCHF),
      FGBP: this.createContract(abis.ERC20, this.tokenIds.FGBP),
      FAUD: this.createContract(abis.ERC20, this.tokenIds.FAUD),
      FOIL: this.createContract(abis.ERC20, this.tokenIds.FOIL),
      FXAU: this.createContract(abis.ERC20, this.tokenIds.FXAU),
      FBTC: this.createContract(abis.ERC20, this.tokenIds.FBTC),
      FETH: this.createContract(abis.ERC20, this.tokenIds.FETH)
    };
    this.baseTokenContracts = this.tokenContracts.DAI;
  }

  createContract(abi, address) {
    return new this.web3.eth.Contract(abi, address);
  }

  getTokenContract(tokenId) {
    return this.createContract(this.protocol.abis.ERC20, tokenId);
  }

  getBaseContract(name) {
    return this.baseContracts[name];
  }

  getMarginPoolInterfaceContract(poolId) {
    return this.createContract(this.protocol.abis.MarginLiquidityPoolInterface, poolId);
  }

  getSyntheticPoolInterfaceContract(poolId) {
    return this.createContract(this.protocol.abis.SyntheticLiquidityPoolInterface, poolId);
  }

  getSyntheticFlowTokenContract(tokenId) {
    return this.createContract(this.protocol.abis.SyntheticFlowToken, tokenId);
  }

}

var _default = LaminarContract;
exports.default = _default;